<template>
    <v-expansion-panel class="side-list" :class="`${color} lighten-5`">
        <v-expansion-panel-header class="side-list__title">
            <span> {{ title }} </span>
            <template v-if="content">
                <v-spacer />
                <v-badge inline class="side-list__badge" v-bind="{ color, content }" />
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row class="ma-n1">
                <template v-for="type in types">
                    <v-col class="pa-1" cols="12" :key="type">
                        <side-item v-bind="{ side, type, items }" />
                    </v-col>
                </template>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES, initEmploymentForm, initEmploymentField } from "@/assets/variables";

import SideItem from "./side-item.vue";

const types = Object.keys(EMPLOYMENT_FIELD_TYPES).filter((item) => item != EMPLOYMENT_FIELD_TYPES.FILE.value);

export default {
    components: {
        SideItem,
    },
    props: {
        side: { type: String, default: EMPLOYMENT_FIELD_SIDES.DOCUMENT.value },
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),

        types,
    }),
    computed: {
        color() {
            return EMPLOYMENT_FIELD_SIDES[this.side]?.color;
        },
        content() {
            return this.items.length || 0;
        },
        title() {
            return EMPLOYMENT_FIELD_SIDES[this.side]?.text;
        },
        items() {
            return this.form.fields.filter(({ side }) => side == this.side);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },

        emit() {
            this.$emit("input", this.form);
        },

        push(item) {
            let { side } = this;
            this.form.fields.push(initEmploymentField({ ...item, side }));
            this.emit();
        },

        pull(item) {
            let index = this.form.fields.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.form.fields.splice(index, 1);
            this.emit();
        },

        updateItem(item) {
            let index = this.form.fields.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.form.fields.splice(index, 1, item);
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
.side-list {
    border: thin solid var(--border-color);
    border-radius: inherit;

    &:not(:first-child) {
        margin-top: 16px;
    }

    &__title {
        font-size: 16px;
        font-weight: bold;
    }
    &__badge {
        ::v-deep .v-badge__wrapper {
            top: 0;
            left: 0;
        }
    }
}
</style>
